import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-3 col-md-4" }
const _hoisted_3 = { class: "col-xl-8 col-lg-9 col-md-8" }
const _hoisted_4 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap pb-4 border-bottom" }
const _hoisted_7 = { class: "d-flex position-relative top-3" }
const _hoisted_8 = { class: "pe-0 border-0 bg-transparent ms-4 ps-2" }
const _hoisted_9 = { class: "pe-0 border-0 bg-transparent ms-2" }
const _hoisted_10 = { class: "pe-0 border-0 bg-transparent ms-2" }
const _hoisted_11 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_12 = { class: "default-table-area email-list" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailSidebar = _resolveComponent("EmailSidebar")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EmailSidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"form-check\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexCheckDefault\"><div class=\"form-check-label\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-danger dropdown-toggle p-0 border-0 ps-0 bg-transparent\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"></button><ul class=\"dropdown-menu bg-white box-shadow\" style=\"border:1px solid #f6f7f9;\"><li><a class=\"dropdown-item fs-13\" href=\"#\">All</a></li><li><a class=\"dropdown-item fs-13\" href=\"#\">None</a></li><li><a class=\"dropdown-item fs-13\" href=\"#\">Read</a></li><li><a class=\"dropdown-item fs-13\" href=\"#\">Unread</a></li><li><a class=\"dropdown-item fs-13\" href=\"#\">Starred</a></li><li><a class=\"dropdown-item fs-13\" href=\"#\">Untarred</a></li></ul></div></div></div>", 1)),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " archive ", -1)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'Archive',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " help_clinic ", -1)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'Help',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " delete ", -1)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'Trash',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[3] || (_cache[3] = [
                _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 text-body hover\"> more_vert </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
              ]))])), [
                [
                  _directive_b_tooltip,
                  'More_Option',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ])
            ]),
            _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"d-flex align-items-center\"><span class=\"fs-12 fw-medium me-2\">1 - 5 of 12</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><a class=\"page-link icon\" href=\"#\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\"> keyboard_arrow_left </i></a></li><li class=\"page-item\"><a class=\"page-link icon\" href=\"#\" aria-label=\"Next\"><i class=\"material-symbols-outlined\"> keyboard_arrow_right </i></a></li></ul></nav></div></div>", 1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault2"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, " restart_alt ")
                        ])
                      ])
                    ], -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Google")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" 2-Step Verification Turn Off ", -1),
                          _createElementVNode("span", { class: "text-body" }, " - Integer nec arcu ac nisi... ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "20 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault3"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, " restart_alt ")
                        ])
                      ])
                    ], -1)),
                    _cache[12] || (_cache[12] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Facebook")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" Friend Request ", -1),
                          _createElementVNode("span", { class: "text-body" }, " - Sed in libero eget lorem fermentum... ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "21 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault4"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Linkedin")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("Travel Information ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Vivamus vestibulum ligula in mauris...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "22 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault5"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Ethan Parker")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("Leave Application ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Integer nec arcu ac nisi...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "23 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[23] || (_cache[23] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault6"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[24] || (_cache[24] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Dribbble")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("Design Inspiration ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Sed in libero eget lorem fermentum...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "24 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[27] || (_cache[27] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault7"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[28] || (_cache[28] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Instagram")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                          _createTextVNode("Training Schedule ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Vivamus vestibulum ligula in mauris...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[29] || (_cache[29] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "25 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault8"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[32] || (_cache[32] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Isabella Cooper")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("Internal Auditor ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Sed in libero eget lorem fermentum...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "26 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[35] || (_cache[35] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault9"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[36] || (_cache[36] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Google")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                          _createTextVNode("Password Changed ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Integer nec arcu ac nisi...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[37] || (_cache[37] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "27 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[39] || (_cache[39] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault10"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[40] || (_cache[40] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Olivia Rodriguez")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                          _createTextVNode("Virtual Training ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Vivamus vestibulum ligula in mauris...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "28 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[43] || (_cache[43] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault11"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[44] || (_cache[44] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "YouTube")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                          _createTextVNode("New Subscriber ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Sed in libero eget lorem fermentum...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[45] || (_cache[45] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "29 JULY 2024")
                    ], -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[47] || (_cache[47] = _createElementVNode("td", { class: "ps-0" }, [
                      _createElementVNode("div", { class: "d-flex align-items-center" }, [
                        _createElementVNode("div", { class: "form-check me-4" }, [
                          _createElementVNode("input", {
                            class: "form-check-input wh-20",
                            type: "checkbox",
                            value: "",
                            id: "flexCheckDefault12"
                          })
                        ]),
                        _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body position-relative top-1" }, "restart_alt")
                        ])
                      ])
                    ], -1)),
                    _cache[48] || (_cache[48] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "fs-14 fw-medium" }, "Google")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/apps/email/read-email",
                        class: "w-330 d-inline-block text-truncate text-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                          _createTextVNode("Security Alert ", -1),
                          _createElementVNode("span", { class: "text-body" }, "- Vivamus vestibulum ligula in mauris...", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[49] || (_cache[49] = _createElementVNode("td", { class: "text-end pe-0 fs-12" }, [
                      _createElementVNode("span", null, "30 JULY 2024")
                    ], -1))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}